module.exports = {"130428100":"肥乡镇","130428101":"天台山镇","130428102":"辛安镇镇","130428200":"大西韩乡","130428202":"毛演堡乡","130428203":"元固乡","130428204":"屯庄营乡","130428205":"东漳堡乡","130428206":"旧店乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130428.json
// module id = 109
// module chunks = 0